// extracted by mini-css-extract-plugin
export default {"container":"style_container__iqJik","page":"style_page__6lJkJ","error":"style_error__sDAC1"};